import { Exhibitor, extractExhibitorSummaries, ExhibitorStand, filterExhibitorStands, ExhibitorWithStand } from 'globals/store/exhibitors.data'
import {filterExhibitors} from 'src/app/store/exhibitors.functions';
import { createSelector } from '@ngrx/store'
import { WFWorker } from 'globals/store/workforce.data'
import { LabelMaps, JoiEvent } from 'globals/store/events.data'
import { ItemStatus, PublicEditProfileInfo, shareUrlsByType, StandItemInfo } from 'globals/store/share.data'
import { convertObjectMapToList, getNestedList, makeMapFromListOfObjectsAndKey, sortByProp, sortByPropOfNumber } from 'globals/store/../helpers/helpers'
import { ExhibitorsTableData, ExhibitorBriefTableData, ExhibitorStandsTableData } from 'src/app/helpers/table-column-types'
import { getBooleanLight, getBooleanConfirmedLight, getActiveLights, NestedProgramInfo, getAssetLights } from './performerSponsors.reselector'
import { columnOrderTypes, defaultColumns } from 'src/app/store/settings.era'
import { exhibitorColumnsById, tableLightColors, allDefaultExhibitorStandsColumns, exhibitorStandColumnsById } from 'src/app/helpers/table-helpers'
import { getExhibitorBriefActions, getExhibitorStandIdsByExhibitorId } from 'globals/store/share.brief.functions'
import { environment } from '../../../environments/environment'
import { Dictionary } from '@ngrx/entity'
import { programsArray } from './programs.reselector'
import { Program, getExhibitorStandIdsByProgramId } from 'globals/store/programs.data'
import { getMediaTermsLights } from "./entity.reselector.helpers";
import { EntitySubTable, exhibitorSubTableTypes, subTableIds } from 'globals/store/entity.data'
import { TableColumn } from 'src/app/helpers/table.data'
import { exhibitorListReselector, getBaseExhibitorTableData, getReadyAssetLights } from './entity.decircular.reselector'
import { allAssociatedAssetsIdsReselector } from './entity.reselector'
import { BriefActions } from 'globals/store/brief.data'
import { exhibitorStandsStateSelector } from '../exhibitor.stands.era';
import { eventStateSelector } from '../events.era';
import { shareStateSelector } from '../share.era';
import { exhibitorsStateSelector } from '../exhibitors.era';

const workersByEmail = (store) => store.workforce.workersByEmail
const labelMaps = (store) => store.events.labelMaps
const exhibitorTableFilters = (store) => store.filters.exhibitors
const exhibitorStandTableFilters = (store) => store.filters.exhibitor_stands
const exhibitorProfileEditShareables = (store) => store.shareables.exhibitor
const standTypes = (store) => store.exhibitors.standTypes
const programs = (store) => store.programs.entities
const userSettings = (store) => store.settings.user
const exhibitorBriefs = (store) => store.shareables.exhibitorBrief
const exhibitorBriefSearchTerm = (store) => store.filters.exhibitor_brief.search
const exhibitorEntities = createSelector(exhibitorsStateSelector, (state) => state.entities)
const exhibitorStandEntities = createSelector(exhibitorStandsStateSelector, (state) => state.entities)
const exhibitorIds = (store) => store.exhibitors.ids
const event = createSelector(eventStateSelector, (state) => state.event)
const eAssets = (store) => store.shareables.eAsset
const eRequest = createSelector(shareStateSelector, (state) => state.eRequest)
const entityAssetShareables = (store) => store.shareables.entityAsset
const exhibitorTypes = (store) => store.exhibitors.exhibitorTypes
const assets = (store) => store.assets.entities

const SearchableExhibitorFields = ['name']


export const exhibitorStandListReselector = createSelector(
  exhibitorStandEntities,
  (exhibitorStands) => convertObjectMapToList(exhibitorStands).sort(sortByProp('name'))
)

export const exhibitorBriefActionsReselector = createSelector(
  exhibitorProfileEditShareables,
  event,
  exhibitorStandListReselector,
  programs,
  eRequest,
  entityAssetShareables,
  getExhibitorBriefActions
)

export const allExhibitorBriefActionsReselector = createSelector(
  exhibitorProfileEditShareables,
  event,
  exhibitorIds,
  exhibitorStandListReselector,
  programs,
  eRequest,
  entityAssetShareables,
  (profiles: { [id: string]: PublicEditProfileInfo }, event: JoiEvent, exhibitorIds: string[], exhibitorStands, programs, eRequest, entityAssetShareables) => {
    const briefActionsMap: { [eId: string]: BriefActions} = {}
    exhibitorIds.forEach(eId => briefActionsMap[eId] = getExhibitorBriefActions(profiles, event, exhibitorStands, programs, eRequest, entityAssetShareables, eId))
    return briefActionsMap
  }
)

export const exhibitorStandIdsByProgramIdFactory = (programId: string) => createSelector(
  exhibitorStandListReselector,
  (exhibitorStandList: ExhibitorStand[]) => exhibitorStandList.filter(s => s.programId === programId).sort(sortByPropOfNumber('programIndex')).map(s => s.id)
)
export const exhibitorStandIdsByProgramIdReselector = createSelector( // for manage program and the exhibitor stands component
  exhibitorStandListReselector,
  (exhibitorStandList: ExhibitorStand[], programId: string) => exhibitorStandList.filter(s => s.programId === programId).sort(sortByPropOfNumber('programIndex')).map(s => s.id)
)

export const exhibitorStandIdsByExhibitorIdReselector = createSelector( // for manage program and the exhibitor stands component
  exhibitorStandListReselector,
  getExhibitorStandIdsByExhibitorId
)

export const exhibitorStandIdsByAllProgramIdsReselector = createSelector( // for manage program and the exhibitors component
  exhibitorStandEntities,
  getExhibitorStandIdsByProgramId
)

export const standSelectorDialogDataByProgramAndExhibitorIdReselector = createSelector(
  programsArray,
  exhibitorStandListReselector,
  exhibitorEntities,
  (programsArray: Program[], stands: ExhibitorStand[], exhibitors, exhibitorId): NestedProgramInfo[] => {
    return programsArray.map(p => ({
        programId: p.id,
        programTitle: p.title,
        standList: stands
          .filter(s => s.programId === p.id && s && s.exhibitorId !== exhibitorId)
          .map(s => ({
          id: s.id, name: s.name, selected: false, message: !exhibitors[s.exhibitorId] ? '' : `Assigned to: ${exhibitors[s.exhibitorId].name}`, disabled: !!exhibitors[s.exhibitorId]
        }))
      }))
      .filter(p => p.standList.length)
  }
)


export const exhibitorColumnsReselector = createSelector(
userSettings,
(settings) => {

  const tableColumnsMap: { [t in EntitySubTable]: TableColumn[] } = {} as { [t in EntitySubTable]: TableColumn[] }
  subTableIds.forEach(id => {
    if (id === 'responses') return
    const selectedColumns = !settings ? null : settings[`${exhibitorSubTableTypes[id]}_columns`]
    const defaults = defaultColumns[exhibitorSubTableTypes[id]]
    const columns = selectedColumns || defaults
    if (columns) tableColumnsMap[id] = columns.filter(c => c.selected).map(c => exhibitorColumnsById[c.value]).filter((c: TableColumn) => !c.notOuter)
  })
  return tableColumnsMap

})

export const exhibitorStandColumnsReselector = createSelector(
  userSettings,
  (settings) => {
    const selectedColumns = !settings ? null : settings[`${columnOrderTypes.exhibitor_stands}_columns`]
    // console.log({ selectedColumns, settings })
    return (!selectedColumns ? allDefaultExhibitorStandsColumns : selectedColumns.filter(c => c.selected).map(c => exhibitorStandColumnsById[c.value]))
  }
)


export const exhibitorSummaryReselector = createSelector(
  event,
  programs,
  extractExhibitorSummaries
)

export const exhibitorBriefsReselector = createSelector(
  exhibitorEntities,
  exhibitorBriefs,
  exhibitorBriefSearchTerm,
  event,
  (exhibitorEntities, exhibitorBriefs, searchTerm: string, event: JoiEvent) => {
    searchTerm = searchTerm ? searchTerm.toLocaleUpperCase() : null
    const briefTableData: ExhibitorBriefTableData[] = Object.values(exhibitorEntities)
      .filter(({ name }) => !searchTerm || name.toLocaleUpperCase().includes(searchTerm))
      .map((exhibitor: Exhibitor) => {
        const { id, name, confirmed } = exhibitor
        const status = getBooleanConfirmedLight(confirmed)
        const brief = exhibitorBriefs[id]
        const briefTableRow: ExhibitorBriefTableData = {
          id,
          name: { text: name },
          status,
          briefUrl: {
            percent:!brief || brief.status === 'Off' ? -1 : 1,
            lights: [{
              text: brief ? brief.status : 'Off',
              color: !brief || brief.status === 'Off' ? tableLightColors.gray : tableLightColors.green,
            }]},
          exhibitor
        }
        return briefTableRow
      })
    const briefTableRowsById = makeMapFromListOfObjectsAndKey(briefTableData, 'id')
    return { briefTableData, briefTableRowsById }
  }
)

const exhibitorsTablePreselector = createSelector(
  exhibitorListReselector,
  workersByEmail,
  labelMaps,
  assets,
  exhibitorProfileEditShareables,
  standTypes,
  allAssociatedAssetsIdsReselector,
  ( exhibitorList: Exhibitor[], workersByEmail: { [email:string]: WFWorker }, labelMaps: LabelMaps, assets,
    exhibitorShareables: { [sId:string]: PublicEditProfileInfo }, standTypes, associatedAssetIdByEntityId ) => 
    ({ exhibitorList, workersByEmail, labelMaps, exhibitorShareables, standTypes, associatedAssetIdByEntityId, assets })
)

export const exhibitorsTableReselector = createSelector(
  exhibitorsTablePreselector,
  exhibitorTypes,
  exhibitorTableFilters,
  programs,
  exhibitorBriefs,
  event,
  allExhibitorBriefActionsReselector,
  ( { exhibitorList, workersByEmail, labelMaps, exhibitorShareables, associatedAssetIdByEntityId, assets },
    exhibitorTypes,
    exhibitorTableFilters,
    programs, 
    exhibitorBriefs,
    event,
    briefActionsMap: { [sId: string]: BriefActions }
  ) => {

    if (!programs || !event || !exhibitorList?.length) return null
    exhibitorList = filterExhibitors(exhibitorTableFilters, programs, exhibitorList, event).exhibitorList
    const { search } = exhibitorTableFilters
    if (search) {
      const searchTerm = search.toLocaleLowerCase()
      exhibitorList = exhibitorList.filter(e => SearchableExhibitorFields.some(field => e[field] && e[field].toLocaleLowerCase().includes(searchTerm)))
    }

    const exhibitorTableData: ExhibitorsTableData[] = exhibitorList.map((exhibitor: ExhibitorWithStand): ExhibitorsTableData => {
    
      const { id, workforceContactEmail, confirmed, detailsConfirmed, labels, hideInPublish, entityTypeId } = exhibitor
      const stands = Object.values(event.exhibitorStands)
        .filter(s => s.exhibitorId === id)
        .sort(sortByPropOfNumber('exhibitorIndex'))

      const standNames = stands.map(s => s.name)
      const standsText = standNames.filter(n => n)
      const nEmpty = standNames.filter(n => !n).length
      if (nEmpty) standsText.push(`${nEmpty} unnamed`)

      const standAssetIds = Array.from(new Set(getNestedList(stands, 'assetIds').filter(id => !!assets[id])))
      const briefInfo = exhibitorBriefs[id]
      const contact = workersByEmail[workforceContactEmail]

      const ePrograms = stands.map(s => programs[s.programId]).filter(p => p)

      const shareable = exhibitorShareables[exhibitor.id]
      const exhibitorLabels = labelMaps.exhibitor_labels
      const briefOn = briefInfo && briefInfo.status === 'On'
      const briefActions = briefActionsMap[id]
      const hasActions = briefOn && !!briefActions?.total
      
      const exhibitorType = !entityTypeId || !exhibitorTypes[entityTypeId] ? null : exhibitorTypes[entityTypeId]
      
      const exhibitorRow: ExhibitorsTableData = {
        ...getBaseExhibitorTableData(exhibitor),
        terms: getMediaTermsLights(event.mediaTerms.exhibitor, exhibitor, briefInfo),
        workforceContact: !contact ? null : contact,
        editingUrlStatus: getActiveLights(!shareable ? null : shareable.status, shareable ? environment.joi.shareBase + shareUrlsByType.exhibitor + '/' + shareable.code : null),
        confirmed: getBooleanConfirmedLight(confirmed),
        detailsConfirmed: getBooleanLight(detailsConfirmed),
        labels: labels ? labels.filter(label => exhibitorLabels[label]).map(label => ({ color: exhibitorLabels[label].color, label: exhibitorLabels[label].label })) : [],
        program: { text: !ePrograms.length ? '' : ePrograms.map(p => p.title).join(", ") },
        stands: { text: standsText.join(", ") },
        standAssets: getReadyAssetLights(standAssetIds, assets),
        assets: getReadyAssetLights(associatedAssetIdByEntityId[id], assets),
/*         standNumber: { text: standNumber },
        standSize: { rank: !standType ? 0 : standType.rank, text: !standType ? '' : standType.name },
        standNotes: { text: standNotes }, */
        briefUrl: { url: briefOn ? environment.joi.shareBase + shareUrlsByType.exhibitorBrief + '/' + briefInfo.id : null , percent: briefOn ? 1 : 0, lights: [{ text: briefOn ? 'On' : 'Off', color: briefOn ? tableLightColors.green : tableLightColors.gray }] },
        briefActions: !hasActions ? null : { percent: briefActions.submitted / briefActions.total, lights: [{ text: `${briefActions.submitted} / ${briefActions.total} completed`, color: briefActions.total === briefActions.submitted ? tableLightColors.green : tableLightColors.red }] },
        hideInPublish: getBooleanLight(!hideInPublish),
        exhibitorType: { rank: !exhibitorType ? 0 : exhibitorType.rank, text: !exhibitorType ? '' : exhibitorType.name },
      }
      return exhibitorRow
    })
    const exhibitorTableRowsById = makeMapFromListOfObjectsAndKey(exhibitorTableData, 'id')
    return { exhibitorTableData, exhibitorTableRowsById }
  }
)


const exhibitorStandsTablePreselector = createSelector(
  exhibitorStandListReselector,
  standTypes,
  ( exhibitorStandList: ExhibitorStand[],
    standTypes ) => ({ exhibitorStandList, standTypes })
)

export const exhibitorStandsTableReselector = createSelector(
  exhibitorStandsTablePreselector,
  exhibitorStandTableFilters,
  programs,
  event,
  eRequest,
  assets,
  ( { exhibitorStandList, standTypes }: {  exhibitorStandList: ExhibitorStand[], standTypes },
    exhibitorStandTableFilters,
    programs, 
    event,
    erequests,
    assets
  ) => {

    
    exhibitorStandList = !event ? [] :
      filterExhibitorStands(exhibitorStandTableFilters, programs, exhibitorStandList, event.exhibitors).exhibitorStandList
    const { search } = exhibitorStandTableFilters
    if (search) {
      const searchTerm = search.toLocaleLowerCase()
      exhibitorStandList = exhibitorStandList.filter(s => 
        [programs[s.programId]?.title, s.name, event.exhibitors[s.exhibitorId]?.name]
        .filter(f => f)
        .some(field => field.toLocaleLowerCase().includes(searchTerm))
      )    
    }

    const exhibitorStandTableData: ExhibitorStandsTableData[] = exhibitorStandList.map((exhibitorStand: ExhibitorStand): ExhibitorStandsTableData => {
    
      const { id, standTypeId, name, programId, standNotes, requests, exhibitorId, assetIds } = exhibitorStand

      const standType = !standTypeId || !standTypes[standTypeId] ? null : standTypes[standTypeId]
      const program = !programId || !programs[programId] ? null : programs[programId] 
      const files = requests?.length || 0;

      /* 
      const assetStatus = assetList.filter(({ standId }) => standId === id).map((asset: StandItemInfo): ItemStatus => !asset ? 'Off' : asset.status)
      const assetLights = getAssetLights(assetStatus)
      */
      const standStatus = Object.values(erequests).filter(standRequest => standRequest.standId === id).map((standRequest: StandItemInfo): ItemStatus => !standRequest ? 'Off' : standRequest.status) 

      const standRequests = getAssetLights(standStatus)
      

      const exhibitor = event.exhibitors[exhibitorId]    
      const exhibitorStandRow: ExhibitorStandsTableData = {
        id,
        exhibitor: { text: exhibitor?.name || '' },
        exhibitorStand,
        standNumber: { text: name },
        program: { text: !program ? '' : program.title },
        standRequests,
        standSize: { rank: !standType ? 0 : standType.rank, text: !standType ? '' : standType.name },
        standNotes: { text: standNotes },
        standFiles: { lights: [{ text: ''+files, color: files ? tableLightColors.green : tableLightColors.gray }] },
        standAssets: getReadyAssetLights(assetIds, assets)
      }
      return exhibitorStandRow
    })
    const exhibitorStandTableRowsById = makeMapFromListOfObjectsAndKey(exhibitorStandTableData, 'id')
    return { exhibitorStandTableData, exhibitorStandTableRowsById }
  }
)